import { InjectionKey, Ref } from 'vue';
import { Router } from 'vue-router';

export const RouterKey: InjectionKey<Router> = Symbol('router');
